// extracted by mini-css-extract-plugin
module.exports = {"successMessage":"styles_successMessage__2y49c","successMessage__image":"styles_successMessage__image__He6XC","successMessage__text":"styles_successMessage__text__iOBZs"};